<payee-popup
  [heading]="dialogData?.transition_label"
  [onCancel]="onCancel"
>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <div class="dialog-content">
    @if (dataLoading()) {
      <div class="dialog-data-loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="48"
        ></mat-progress-spinner>
      </div>
    }

    @if (dialogData && !dataLoading()) {
      <h2>Kérlek ellenőrizd, hogy ezt az összeget utalták el:</h2>
      <ul>
        @for (fee of dialogData.fees; track fee.currency + fee.amount) {
          <li>
            {{ fee.amount | currency: fee.currency : "symbol-narrow" : "1.0" : "hu" }}
          </li>
        }
      </ul>
      <p>Az adósok státusza:</p>
      <ul>
        @for (debtor of dialogData.debtorStatuses; track debtor.tax_number ?? debtor.name) {
          <li>
            <strong>{{ debtor.name }}</strong>
            @if (debtor.tax_number) {
              <span>({{ debtor.tax_number }})</span>
            }
            : {{ "COMPANY_STATUS." + debtor.status | translate }}
          </li>
        }
      </ul>
      <form [formGroup]="form">
        <mat-checkbox
          formControlName="link_pro_forma"
          color="primary"
          class="link-pro-forma-checkbox"
        >
          {{ "WORKFLOW_DIALOGS.BOOK_BAILIFF_FEE_PAID_PRO_FORMA.LINK_CHECKBOX" | translate }}
        </mat-checkbox>
        @if (link_pro_forma.value) {
          <div class="pro-forma-row">
            <payee-form-field
              width="short"
              height="tall"
            >
              <payee-dropdown
                width="short"
                height="tall"
                [options]="dialogData.pro_forma_invoice_numbers"
                [selected]="pro_forma.value"
                (selectedChange)="pro_forma.patchValue($event)"
              ></payee-dropdown>
            </payee-form-field>
            <payee-form-field
              width="shorter"
              height="tall"
            >
              <input
                payee-input
                type="text"
                formControlName="pro_forma"
                autocomplete="off"
                [attr.placeholder]="'WORKFLOW_DIALOGS.BOOK_BAILIFF_FEE_PAID_PRO_FORMA.MANUAL_PLACEHOLDER' | translate"
              />
            </payee-form-field>
            <button
              type="button"
              payee-icon-button
              color="white"
              [disabled]="loading"
              (click)="clearProForma()"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
      </form>
    }
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="dataLoading() || loading || dialogData === undefined"
      [loading]="loading"
      (click)="onSubmit()"
    >
      {{ "WORKFLOW_DIALOGS.BOOK_BAILIFF_FEE_PAID_PRO_FORMA.SUBMIT" | translate }}
    </button>
  </ng-template>
</payee-popup>
